import React, { useMemo } from 'react';
import { searchMeshes } from './anatomyRegistry';
import './SearchOverlay.css';

function SideBadge({ side, onClick }) {
  const label = side === 'left' ? 'Left' : side === 'right' ? 'Right' : 'Center';
  return (
    <button
      type="button"
      className={`search-side-badge search-side-${side || 'center'}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
}

function ResultCard({ group, onSelect }) {
  const unilateral = group.sides.length === 1;

  const choose = (side) => {
    onSelect(group.systemId, side.meshKey);
  };

  return (
    <div className="search-result-card">
      <div className="search-result-head">
        <div className="search-result-icon">
          <img src={group.systemIcon} alt="" />
        </div>
        <div className="search-result-titles">
          <span className="search-result-system">{group.systemLabel}</span>
          <span className="search-result-name">{group.baseName}</span>
        </div>
      </div>

      <div className="search-result-sides">
        {unilateral ? (
          <button
            type="button"
            className="search-result-go"
            onClick={() => choose(group.sides[0])}
          >
            View →
          </button>
        ) : (
          group.sides.map((s) => (
            <SideBadge key={s.side || 'center'} side={s.side} onClick={() => choose(s)} />
          ))
        )}
      </div>
    </div>
  );
}

export default function SearchOverlay({ query, onSelect, onClose, anchorRect }) {
  const results = useMemo(() => searchMeshes(query), [query]);

  const panelStyle = anchorRect
    ? { top: anchorRect.bottom + 8 }
    : {};

  return (
    <div className="search-overlay-scrim" onClick={onClose}>
      <div className="search-overlay-panel" style={panelStyle} onClick={(e) => e.stopPropagation()}>
        <div className="search-overlay-scroll-wrap">
          {query.trim() === '' ? (
          <div className="search-overlay-empty">
            <p>Start typing a body part to search across all systems.</p>
            <span className="search-overlay-hint">e.g. femur, optic nerve, left kidney, brachial plexus</span>
          </div>
        ) : results.length === 0 ? (
          <div className="search-overlay-empty">
            <p>No matching parts found.</p>
            <span className="search-overlay-hint">Try a shorter or alternate term.</span>
          </div>
        ) : (
          <div className="search-overlay-results">
            {results.map((g) => (
              <ResultCard key={`${g.systemId}-${g.baseName}`} group={g} onSelect={onSelect} />
            ))}
          </div>
        )}
        </div>
    </div>
    </div>
  );
}
